import { isObject } from "@spoferan/spoferan-ts-core";
import { useRoute, useRouter } from "#app";
import { computed } from "vue";
export function useLinkable(props) {
  const route = useRoute();
  const router = useRouter();
  const hasActiveTo = computed(() => {
    const targetTo = props.to && isObject(props.to) ? router.resolve(props.to) : {
      path: props.to,
      fullPath: props.to
    };
    return !!(targetTo.path && route && (!props.exact && route.path.startsWith(targetTo.path) || props.exact && route.fullPath.split("#")[0] === targetTo.path.split("#")[0]));
  });
  const linkProps = computed(() => {
    if (props.disabled || !props.to) {
      return null;
    }
    return {
      to: isObject(props.to) && props.to.path?.startsWith("http") ? props.to.path : props.to,
      // Absolute URLs cannot be specified as object on nuxt-link
      target: props.target,
      replace: props.replace,
      rel: props.nofollow ? "nofollow noopener" : props.target === "_blank" ? "noopener" : null
    };
  });
  return {
    hasActiveTo,
    linkProps
  };
}
